export const STATEFUL_APP = {
  // RefreshAppToast components
  REFRESH_DIALOG: 'stateful-app-refresh-dialog',
  REFRESH_DIALOG_TITLE: 'stateful-app-refresh-dialog-title',
  REFRESH_DIALOG_ICON: 'stateful-app-refresh-dialog-icon',
  REFRESH_DIALOG_CONTENT: 'stateful-app-refresh-dialog-content',
  REFRESH_DIALOG_ACTIONS: 'stateful-app-refresh-dialog-actions',
  REFRESH_DIALOG_BUTTON: 'stateful-app-refresh-dialog-button',
  REFRESH_TOAST_LINK: 'stateful-app-refresh-toast-link',

  // StatefulAppLoadError components
  LOAD_ERROR: 'stateful-app-load-error',
  LOAD_ERROR_RETRY_BUTTON: 'stateful-app-load-error-retry-button',
  LOAD_ERROR_LOGOUT_BUTTON: 'stateful-app-load-error-logout-button'
} as const;
